export { default } from "./ReportContent";
